import firebase, { getFacebookProvider } from './firebase';

export const FIREBASE_TYPE = {
  SIGNIN_EMAIL: 'SIGNIN/EMAIL',
  SIGNIN_FACEBOOK: 'SIGNIN/FACEBOOK',
  SIGN_UP_EMAIL: 'SIGN_UP/EMAIL',
  SIGNIN_ANONYMOUS: 'SIGNIN/ANONYMOUSLY',
  SIGNOUT: 'SIGNOUT',
  GET_USER: 'GET_USER',
  ADD_PERSONAL_INFORMATION: 'ADD_PERSONAL_INFORMATION',
};

export async function signInWithEmail(email, password) {
  return firebase.auth().signInWithEmailAndPassword(email, password);
}

export async function signUpWithEmail(email, password) {
  return await firebase.auth().createUserWithEmailAndPassword(email, password);
}

export async function signInWithFacebook() {
  try {
    const provider = getFacebookProvider();
    const result = await firebase.auth().signInWithPopup(provider);
    return result;
  } catch (error) {
    throw error;
  }
}

export async function forgotPassword(email) {
  try {
    const result = await firebase.auth().sendPasswordResetEmail(email);
    return result;
  } catch (error) {
    return error;
  }
}

export async function checkFirstTimeLogin() {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) return false;

  const userId = currentUser.uid;
  const userRef = firebase.database().ref('users/' + userId);
  const snapshot = await userRef.once('value');
  const isFirstTime = !(snapshot.val() && !snapshot.val().firstTimeLogin);
  return isFirstTime;
}

const withFirstTimeLogin = async fn => {
  const result = await fn();
  const isFirstTimeLogin = await checkFirstTimeLogin();
  if (result) return { ...result, isFirstTimeLogin };
};

export async function addPersonalInformation() {
  const currentUser = firebase.auth().currentUser;

  const userId = currentUser.uid;
  const userRef = firebase.database().ref('users/' + userId);
  await userRef.update({ firstTimeLogin: false });

  return { currentUser, isFirstTimeLogin: false };
}

export async function signInWithFacebookPreventFirstTime() {
  return withFirstTimeLogin(signInWithFacebook);
}

export async function signOut() {
  // console.log('signout...');
  return firebase.auth().signOut();
}

export async function signInAnonymously() {
  return firebase.auth().signInAnonymously();
}

let user = undefined;

export async function getUser() {
  if (user === undefined) {
    try {
      user = await onAuthStateChanged();
    } catch (error) {
      user = null;
    }
    return user;
  } else {
    user = firebase.auth().currentUser;
    return user;
  }
}

export async function getUserCheckFirstTime() {
  return withFirstTimeLogin(getUser);
}

export function onAuthStateChanged() {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        resolve(user);
      } else {
        reject(null);
      }
    });
  });
}
